import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import {
  UiMonthSelectComponent,
  UiSelectComponent,
  UiSelectOption,
  UiYearSelectComponent,
} from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

const CITIES: UiSelectOption[] = [
  { id: 1, label: 'Ciudad de México' },
  { id: 2, label: 'Guadalajara' },
  { id: 3, label: 'Monterrey' },
  { id: 4, label: 'Puebla' },
  { id: 5, label: 'Tijuana' },
  { id: 6, label: 'León' },
  { id: 7, label: 'Juárez' },
  { id: 8, label: 'Mérida' },
  { id: 9, label: 'San Luis Potosí' },
  { id: 10, label: 'Querétaro' },
];

const PROPERTY_TYPES: UiSelectOption[] = [
  { id: 'casa', label: 'Casa' },
  { id: 'depto', label: 'Departamento' },
  { id: 'terreno', label: 'Terreno' },
  { id: 'comercial', label: 'Local comercial', disabled: true },
  { id: 'oficina', label: 'Oficina' },
];

@Component({
  selector: 'app-select-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiSelectComponent, UiYearSelectComponent, UiMonthSelectComponent, AppExampleSectionComponent],
  templateUrl: './select-doc.component.html',
  styleUrl: './select-doc.component.scss',
})
export class SelectDocComponent {
  protected readonly cities = CITIES;
  protected readonly propertyTypes = PROPERTY_TYPES;

  protected readonly selectedCity = signal<UiSelectOption | null>(null);
  protected readonly selectedType = signal<UiSelectOption | null>(null);
  protected readonly selectedYear = signal<UiSelectOption | null>(null);
  protected readonly selectedMonth = signal<UiSelectOption | null>(null);
  protected readonly isInvalid = signal(false);
  protected readonly showErrorMsg = signal(true);

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }

  protected toggleErrorMsg(): void {
    this.showErrorMsg.update((v) => !v);
  }
}
